/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Score_Signal_ContextualInputs */

const en_directory_detail_score_signal_contextual = /** @type {(inputs: Directory_Detail_Score_Signal_ContextualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contextual`)
};

const zh_directory_detail_score_signal_contextual = /** @type {(inputs: Directory_Detail_Score_Signal_ContextualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`依赖场景`)
};

/**
* | output |
* | --- |
* | "Contextual" |
*
* @param {Directory_Detail_Score_Signal_ContextualInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_score_signal_contextual = /** @type {((inputs?: Directory_Detail_Score_Signal_ContextualInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Score_Signal_ContextualInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_score_signal_contextual(inputs)
	return zh_directory_detail_score_signal_contextual(inputs)
});
export { directory_detail_score_signal_contextual as "directory.detail.score_signal.contextual" }